import { Button, Modal } from "antd";
import React, { useState } from "react";
import TextEditor from "./TextEditor";
import { EditOutlined } from '@ant-design/icons';


export default function RichTextEditor(props) {

    const { width = 900, disabled = false, hold = false, onChange = () => {}, onFinish = () => {}, value = "", link_id = 0, paragraph_preset = 0 } = props;
    const [expand, setExpand] = useState(false);

    const [held, setHeld] = useState(value); 

    const onChangeIntercept = (e) => {
        if(hold){
            setHeld(e);
        } else {
            onChange(e);
        }
    }

    return (
        <>
            <Modal footer={null} closable={false} bodyStyle={{"padding" : "0px"}} width={width} open={expand} onCancel={() => {setExpand(false); onFinish(held)}} destroyOnClose>
                <TextEditor paragraph_preset={paragraph_preset} link_id={link_id} expand={expand} setExpand={setExpand} toolbar_size={"middle"}  {...props} onChange={onChangeIntercept} />
                <div style={{"padding" : "10px"}} className="float-flex">
                    <div>&nbsp;</div>
                    <Button onClick={() => {setExpand(false); onFinish(held);}} type="primary" size="small"><small>Done</small></Button>
                </div>
            </Modal>

           <div>

                <Button disabled={disabled} block onClick={() => setExpand(!expand)}><small><EditOutlined /> Edit text</small></Button>
                {/* <ParagraphUI value={paragraph} onChange={(_v) => setData({...data, "paragraph" : _v})} /> */}
                {/* <TextEditor expand={expand} setExpand={setExpand} toolbar_size={"small"} {...props} /> */}
                
            </div>

            
        </>
    )
}